import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Popover } from "native-base";
import { toggleInArray } from "@madmedical/utils";
import Badge from "../atoms/Badge";
import Button from "../atoms/Button";
import Dropdown from "../molecules/Dropdown";
import Checkbox from "../atoms/Checkbox";
const FilterButton = ({ dropdownPosition = "bottom left", items, isSearchable = false, isMultiselect, onChange, title, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpenPress = () => {
        setIsOpen((prevState) => !prevState);
    };
    const selectedKeys = items
        .filter(({ isSelected }) => isSelected)
        .map(({ key }) => key);
    const handleItemChange = (key) => () => {
        onChange(isMultiselect ? toggleInArray(selectedKeys, key) : [key]);
    };
    const handleReset = () => {
        onChange([]);
    };
    const filterable = items.map(({ key, text, isSelected }) => ({
        key,
        text,
        formControl: (_jsx(Checkbox, { value: key, isChecked: isSelected, onChange: handleItemChange(key), borderRadius: isMultiselect ? 4 : 100 })),
    }));
    return (_jsx(Popover, Object.assign({ useRNModal: true, placement: dropdownPosition, trigger: (triggerProps) => (_jsxs(Box, Object.assign({ position: "relative" }, { children: [_jsx(Button, Object.assign({}, triggerProps, { size: "xs", variant: isOpen && selectedKeys.length >= 0
                        ? "ghostSuccess"
                        : "outlined", rightIconName: `chevron${isOpen ? "Up" : "Down"}`, onPress: handleOpenPress, borderColor: `${isOpen ? "green" : "gray"}.300`, borderWidth: isOpen ? 1 : undefined, bgColor: isOpen ? "white" : undefined }, { children: title })), isMultiselect && selectedKeys.length ? (_jsx(Badge, Object.assign({ size: "xs", position: "absolute", top: -4, right: -4, variant: "ghostSuccess", hasIndicator: false, px: 1, borderColor: `${isOpen ? "green" : "gray"}.300`, borderWidth: isOpen ? 1 : undefined, bgColor: isOpen ? "white" : undefined }, { children: selectedKeys.length }))) : null] }))), isOpen: isOpen, onClose: () => setIsOpen(!isOpen) }, { children: _jsx(Popover.Content, Object.assign({ borderColor: "gray.100", bgColor: "transparent", overflow: "hidden" }, { children: _jsx(Dropdown, { hasSearch: isSearchable, title: title, list: filterable, minWidth: 72, maxWidth: 80, onReset: handleReset }) })) })));
};
export default FilterButton;
